import React from "react";
import { useDrop } from "react-dnd";
import hands from "../assets/hands.png";
import "./CashRegisterDrop.css";

const CashRegisterDrop = ({ moneyInserted = [], onDropMoney }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: "MONEY",
    drop: (item) => onDropMoney(item.value),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  return (
    <div ref={drop} className="cash-register">
      <div
        className="register-image-wrapper"
        style={{ position: "relative", marginTop: "12px" }}
      >
        {/* The hands image underneath */}
        <img src={hands} alt="Cash Register" className="register-image" />
      </div>
    </div>
  );
};

export default CashRegisterDrop;
